export const reviews2 = (Swiper)=> {

    const swiper = new Swiper('.reviews-2__swiper', {
        spaceBetween: 10,
        slidesPerView: 1.11,
        pagination: {
            el: '.reviews-2__pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 1.5,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                spaceBetween: 30,
                slidesPerView: 3,
            }
        }
    });

}